import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SessionData, SessionCart} from '../types/TypesSession';

export type AppSliceStateType = {
	appData: any;
	session: SessionData;
};

const initialSessionState: SessionData = {
	token: null,
	language: null,
	cstcode: null,
	role_id: null,
	role_name: null,
	user_id: null,
	currency: null,
	cart: null,
	csrf_token: null,
	location: null,
	refcode: null,
	month_now: null,
};

const initialState: AppSliceStateType = {
	appData: null,
	session: initialSessionState,
};

const appSlice = createSlice({
	name: 'appData',
	initialState,
	reducers: {
		setAppData: (state, action: PayloadAction<any | null>) => {
			state.appData = action.payload;
		},
		setSession: (state, action: PayloadAction<any>) => {
			const data = action.payload ?? {};
			const incomingRoleId =
				data?.api_role_id !== undefined && data?.api_role_id !== null
					? Number(data.api_role_id)
					: data?.role_id !== undefined && data?.role_id !== null
					? Number(data.role_id)
					: null;
			const normalizedRoleId = incomingRoleId ?? 2;
			state.session = {
				...state.session,
				role_id: normalizedRoleId,
				role_name: data?.role_name ?? state.session.role_name ?? null,
				user_id: data?.api_user_id ?? null,
				currency: data?.currency_code ?? null,
				cstcode: data?.api_cstcode ?? null,
				csrf_token: data?.csrf_token ?? null,
				location: data?.location_id ?? null,
				language: data?.language_code ?? null,
				month_now: data?.month_now ?? null,
				refcode: data?.refcode ?? null,
			};
		},
		setToken: (state, action: PayloadAction<string | null>) => {
			state.session.token = action.payload;
		},
		setCart: (state, action: PayloadAction<SessionCart>) => {
			state.session.cart = action.payload;
		},
	},
});

export const {setAppData, setSession, setToken, setCart} =
	appSlice.actions;
export default appSlice.reducer;
